import { Component, Input, computed, signal } from '@angular/core';
import {
  DEFAULT_STATUS_BADGE_STYLE,
  STATUS_BADGE_STYLES,
} from '../../../core/config/status-badge.config';

@Component({
  selector: 'pp-status-badge',
  standalone: true,
  template: `
    <span
      class="inline-flex items-center rounded-full px-2 py-0.5 text-[12px] font-medium whitespace-nowrap"
      [class]="style().classes"
    >
      {{ style().label }}
    </span>
  `,
})
export class StatusBadgeComponent {
  private readonly statusSignal = signal('');

  @Input({ required: true })
  set status(value: string) {
    this.statusSignal.set(value);
  }

  readonly style = computed(
    () => STATUS_BADGE_STYLES[this.statusSignal()] ?? { ...DEFAULT_STATUS_BADGE_STYLE, label: this.statusSignal() },
  );
}
